import axios from 'axios';
import * as cookie from 'cookies-next';
import { COOKIE_NAME, COOKIE_NAME_API } from '../data/cookie';

export const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_URL,
  headers: {
    'x-token': cookie.getCookie(COOKIE_NAME_API),
  },
});

axiosInstance.interceptors.request.use(null, (error) => {
  const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;

  if (!expectedError) {
    console.log('an unexpected error occurred!');
  }
  Promise.reject(error);
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      cookie.deleteCookie(COOKIE_NAME_API); // Clear the cookie if unauthorized
      cookie.deleteCookie(COOKIE_NAME); // Clear the main cookie as well
      console.error('Unauthorized access - redirecting to login');
      // On the server, you can't use window or js-cookie
      // You can throw an error or handle redirect in your route handler
      // Example: throw new Error('Unauthorized');
      // Or just rethrow for your handler to catch
    }
    return Promise.reject(error);
  }
);
